import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { FaMicrosoft, FaGoogle, FaApple } from 'react-icons/fa';
import { SiGmail, SiWhatsapp, SiTelegram, SiNotion, SiSpotify, SiUber, SiAirbnb, SiGooglecalendar } from 'react-icons/si';

const tools = [
  { icon: SiWhatsapp, name: 'WhatsApp' },
  { icon: SiGmail, name: 'Gmail' },
  { icon: FaMicrosoft, name: 'Outlook' },
  { icon: SiGooglecalendar, name: 'Google Cal' },
  { icon: FaApple, name: 'iMessage' },
  { icon: SiTelegram, name: 'Telegram' },
  { icon: SiNotion, name: 'Notion' },
  { icon: FaGoogle, name: 'Google' },
  { icon: SiSpotify, name: 'Spotify' },
  { icon: SiUber, name: 'Uber' },
  { icon: SiAirbnb, name: 'Airbnb' },
  { icon: FaMicrosoft, name: 'Teams' },
];

const Integrations = () => (
  <section className="py-24 bg-[#F8F6F3] border-t border-[#E8E2DA]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="tag-pill mx-auto mb-5 w-fit">Works where you do</div>
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A1A18] mb-4 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
          Claw lives in the apps<br /><span className="gradient-text-accent">you already use.</span>
        </h2>
        <p className="text-[#6B6560] text-base leading-relaxed">
          No new app to learn. Claw meets you in WhatsApp, email, iMessage — wherever you already are.
        </p>
      </div>
      <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
        {tools.map((tool) => (
          <div key={tool.name}
            className="group flex items-center gap-2 px-4 py-2.5 bg-white border border-[#E8E2DA] hover:border-[#B8CDD9] rounded-xl transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md cursor-default">
            <tool.icon className="text-base text-[#9E9690] group-hover:text-[#1A1A18] transition-colors" />
            <span className="text-sm font-medium text-[#6B6560] group-hover:text-[#1A1A18] transition-colors">{tool.name}</span>
          </div>
        ))}
        <div className="flex items-center gap-2 px-4 py-2.5 bg-[#EBF2F9] border border-[#C8DDE9] rounded-xl">
          <SafeIcon icon={FiIcons.FiPlus} className="text-[#2D6A8F]" />
          <span className="text-sm font-semibold text-[#2D6A8F] font-mono-custom">thousands more</span>
        </div>
      </motion.div>
    </div>
  </section>
);

export default Integrations;